module.exports = [
  { id: 1, title: '이용방법 및 이용정책' },
  { id: 2, title: '요금 및 결제방법' },
];
